const INITIAL_STATE = {
  tryRedirect: false,
  showFilters: true
};

const SearchTeamData = {
  INITIAL_STATE,
}

export default SearchTeamData;